import { Component, OnInit, Input } from '@angular/core';
import { GfTranslateService } from '../../../../../core/services/core.translate.service';
import { TrackerItemValidationService } from '../../../services/trackeritem.validation.service';
import * as _ from 'lodash';

@Component({
  selector: 'csv-result',
  template: require('./csvresult.component.html'),
})
export class CsvResultComponent implements OnInit {
  @Input() tracker: any;
  @Input() result: any;

  hasChanges: boolean;
  hasCreated: boolean;
  hasErrors: boolean;
  isEmpty: boolean;
  errorSummary: any;

  constructor(
    private translateService: GfTranslateService,
    private trackeritemValidationService: TrackerItemValidationService
  ) {}

  ngOnInit() {
    this.hasChanges = _.size(this.result.changes) > 0;
    this.hasCreated = _.size(this.result.created) > 0;
    this.hasErrors = _.size(this.result.errors) > 0;
    this.isEmpty = !this.hasChanges && !this.hasCreated && !this.hasErrors;

    this.errorSummary = _.keys(_.get(this.result, 'errors', {})).reduce((carry, key) => {
      carry[key] = this.getErrorSummary(this.result.errors[key]);
      return carry;
    }, {});
  }

  private getErrorSummary(validations: any): any {
    // Not Found, Not Allowed, and unexpected errors come across as raw strings.
    if (typeof validations === 'string' || validations instanceof String) {
      return validations;
    }

    // Return the generic overwrite message, if needed.
    // In reality, the list below and this item are mutually exclusive.
    if (_.get(validations, 'overwrite', false)) {
      return [this.translateService.translate('This Tracker Item was changed by someone else.')];
    }

    // The list of field-level messages from the validation data.
    return this.trackeritemValidationService.getValidationMessages(this.tracker, validations);
  }
}
